import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private key = 'theme';

  initTheme() {
    const savedTheme = localStorage.getItem(this.key);

    if (savedTheme === 'dark') {
      document.documentElement.classList.add('dark');
    }
  }

  toggleTheme() {
    const html = document.documentElement;

    if (html.classList.contains('dark')) {
      html.classList.remove('dark');
      localStorage.setItem(this.key, 'light');
    } else {
      html.classList.add('dark');
      localStorage.setItem(this.key, 'dark');
    }
  }

  isDark(): boolean {
    return document.documentElement.classList.contains('dark');
  }
}
